/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, ListItem, colors, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DashboardIcon from '@material-ui/icons/Dashboard';
import LocalActivityOutlinedIcon from '@material-ui/icons/LocalActivityOutlined';
import CategoryIcon from '@material-ui/icons/CategoryOutlined';
import i18n from 'translations/langEngine';
import { CommonTranslations } from 'translations/translationKeys';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import TodayIcon from '@material-ui/icons/Today';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import EventNoteIcon from '@material-ui/icons/EventNote';
const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium,
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main,
    },
  },
  subItem: {
    paddingLeft: theme.spacing(4), // Adiciona um deslocamento à direita
  },
  subIcon: {
    color: theme.palette.icon,
    width: 20,
    height: 20,
    marginRight: theme.spacing(1),
  },
}));

const SidebarNav = props => {
  const classes = useStyles();

  const [openCadastro, setOpenCadastro] = useState(false);
  const [openServicos, setOpenServicos] = useState(false);
  const [openClientes, setOpenClientes] = useState(false);

  const [translations, setTranslations] = useState({});

  // Chama a função de tradução ao montar o componente
  useEffect(() => {
    const performsTranslation = async () => {
      const termsNeeded = [
        CommonTranslations.MENU_ITEM_CADASTRO,
        CommonTranslations.MENU_ITEM_SERVICOS,
        CommonTranslations.MENU_ITEM_CATEGORIASERVICOS,
        CommonTranslations.MENU_ITEM_CLIENTE,
        CommonTranslations.MENU_ITEM_MOTIVOCANCELAMENTO,
        CommonTranslations.MENU_ITEM_VENDEDORES,
        CommonTranslations.MENU_ITEM_ORDEMSERVICO,
        CommonTranslations.MENU_ITEM_SAIR,
      ];
      const translations = await i18n.fetchTerms(termsNeeded);
      console.log('tranalstions - side bar front ' + JSON.stringify(translations));
      setTranslations(translations);
    };

    performsTranslation();
  }, []); // O array vazio garante que o efeito seja executado apenas uma vez ao montar

  const handleCadastroClick = () => {
    setOpenCadastro(!openCadastro);
  };
  const handleServicosClick = () => {
    setOpenServicos(!openServicos);
  };
  const handleClientesClick = () => {
    setOpenClientes(!openClientes);
  };

  return (
    <List>
      <ListItem button component={Link} to="/front/dashboard">
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItem>


      <ListItem button component={Link} to="/front/abastecimento">
        <ListItemIcon>
          <LocalGasStationIcon />
        </ListItemIcon>
        <ListItemText primary={translations[CommonTranslations.MENU_ITEM_ORDEMSERVICO] || 'Abastecimento'} />
      </ListItem>

      <ListItem button component={Link} to="/front/escala">
        <ListItemIcon>
          <TodayIcon />
        </ListItemIcon>
        <ListItemText primary={translations[CommonTranslations.MENU_ITEM_ORDEMSERVICO] || 'Escala'} />
      </ListItem>

      <ListItem button component={Link} to="/Logout">
        <ListItemIcon>
          <LockOpenIcon />
        </ListItemIcon>
        <ListItemText primary={translations[CommonTranslations.MENU_ITEM_SAIR] || 'Sair'} />
      </ListItem>
    </List>
  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  pages: PropTypes.array.isRequired,
};

export default SidebarNav;
